'use client';

import { keyframes } from '@ironhack/design-system2/system';
import { type ReactElement, useContext } from 'react';

import {
  ProgressBar,
  type Props as ProgressBarProps,
} from '@/app/components/server/progress-bar';
import { QuizProgressContext } from '../../quiz-progress-context';

type Props = { totalQuestions: number } & ProgressBarProps;

const scaleHeight = keyframes`
  from { height: 0 }
  to { height: "var(--height)" }
`;

export const QuizProgressBar = (props: Props): ReactElement | null => {
  const [currentStep] = useContext(QuizProgressContext) ?? [0];
  if (currentStep === 0) return null;

  const { color, totalQuestions } = props;

  // Total steps adds 2 for call to action screen & results page
  const totalSteps = totalQuestions + 2;
  const progressValue = Math.floor((currentStep * 100) / totalSteps);

  return (
    <ProgressBar
      animation={`${scaleHeight} 250ms`}
      color={color}
      position="sticky"
      top="0"
      value={progressValue}
      zIndex="1" // Z-index to avoid being covered by images
    />
  );
};
